import { useParams } from 'react-router-dom';
import { IconBulb } from '@tabler/icons';
import BookitupAlert from '../../Atoms/BookitupAlert';

const EmailTemplateTooltips = () => {
  const { type } = useParams();
  const messageType = type?.toUpperCase();

  return (
    <>
      {(messageType === 'AVAILABLE' || messageType === 'UNAVAILABLE') && (
        <BookitupAlert title="Tipp" icon={<IconBulb />}>
          Verwende hier nur Platzhalter von Daten, die Du zum Zeitpunkt der Anfrage auch schon hast wie bswp. das
          Event-Datum und ggf. den Namen Deines Kunden. Wenn Du das Kontaktformular Deiner Webseite mit bookitup
          verknüpft hast, solltest Du nur von Daten der Pflichtfelder ausgehen. Andernfalls müsstest Du den Text bei
          einer Anfrage manuell anpassen.
        </BookitupAlert>
      )}
      {messageType === 'OFFER' && (
        <BookitupAlert title="Tipp" icon={<IconBulb />}>
          Wähle unter "Anhänge voreinstellen" -&gt; "Mögliche Dokument-Anhänge" -&gt; "Angebot" aus. Damit wird Dir beim
          Laden dieser Vorlage direkt vorgeschlagen das betreffende Angebot beizufügen.
        </BookitupAlert>
      )}
      {messageType === 'FOLLOW_UP' && (
        <BookitupAlert title="Tipp" icon={<IconBulb />}>
          Füge das betreffende Angebot noch einmal für Deinen Kunden an diese E-Mail an. Wähle dafür unter "Anhänge
          voreinstellen" -&gt; "Mögliche Dokument-Anhänge" -&gt; "Angebot" aus.
          <br />
          Wenn Du dann, in einem konkreten Event, diese Vorlage lädst, kannst Du direkt das betreffende Angebot
          auswählen.
        </BookitupAlert>
      )}
    </>
  );
};

export default EmailTemplateTooltips;
